// Push notification registration via Firebase Cloud Messaging (FCM).
// The web config is fetched from the backend (/firebase-config) at runtime —
// it is public by design, so nothing secret is baked into the bundle.
// When Firebase isn't configured server-side, everything here is a quiet no-op.

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

let _messaging = null;
let _initPromise = null;

async function _getMessaging() {
  if (_messaging) return _messaging;
  if (_initPromise) return _initPromise;

  _initPromise = (async () => {
    try {
      const res = await fetch('/firebase-config');
      const cfg = await res.json();
      if (!cfg.configured) return null;
      const app = initializeApp({
        apiKey: cfg.apiKey,
        authDomain: cfg.authDomain,
        projectId: cfg.projectId,
        messagingSenderId: cfg.messagingSenderId,
        appId: cfg.appId,
      });
      _messaging = getMessaging(app);
      _messaging._vapidKey = cfg.vapidKey;
      return _messaging;
    } catch (error) {
      console.warn('Firebase messaging unavailable:', error);
      return null;
    }
  })();

  return _initPromise;
}

export async function requestNotificationPermission(userId) {
  const messaging = await _getMessaging();
  if (!messaging) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const token = await getToken(messaging, {
      vapidKey: messaging._vapidKey || undefined,
    });
    if (!token) return null;

    const response = await fetch('/messages/push-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ token, device_type: 'web' }),
    });

    if (response.ok) {
      console.log('Push token registered');
      return token;
    }
    console.warn('Push token registration failed:', response.status);
  } catch (error) {
    console.warn('Push token retrieval failed:', error);
  }
  return null;
}

export function onForegroundMessage(callback) {
  _getMessaging().then((messaging) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
      if (callback) callback(payload);
    });
  });
}
